import http from "@http"

//会员管理接口地址
let API = {
    //查询会员列表接口
    MEMBER_URL : "/member/memberList",
    //新增
    ADDMEMBER_URL :"/member/add",
    //修改
    UPDATEMEMBER_URL: "/member/edit",
    //核销
    CONSUME_URL: "/member/consumePoints",
    //删除
    DELETEMEMBER_URL : "/member/delete",

    //上传图片
    UPLOADIMG_URL : "/points/uploadPointsPicture"
}

let pointsAPI = {
    //查询积分列表接口
    LIST_URL : "/points/pointsList",
    //新增
    ADD_URL :"/points/add",
    //修改
    UPDATE_URL: "/points/edit",
    //删除
    DELETE_URL : "/points/delete",
    //审核接口
    APPLY_URL : "/points/applyPoints",
}

// --------------------------会员接口---------------------
//获取会员列表
export function getMember(data){
    return http.post(API.MEMBER_URL,data)
}

//新增与修改接口
export function getAddMember(data){
    //修改
    if (data.id) {
        return http.post(API.UPDATEMEMBER_URL, data)
    } else {
        //新增
        return http.post(API.ADDMEMBER_URL, data)
    }
}

//核销
export function getConsumeMember(data){
    return http.post(API.CONSUME_URL , data)
} 

//删除
export function getDeleteMember(id){
    return http.post(API.DELETEMEMBER_URL +'?id='+ id)
} 

//上传图片
export function getUploadImg(data){
    return http.post(API.UPLOADIMG_URL , data)
} 


//-------------------------积分接口---------------------
//获取积分列表
export function getPoints(data){
    return http.post(pointsAPI.LIST_URL,data)
}

//获取待审核积分列表
export function getPointsApply(data){
    return http.post(pointsAPI.LIST_URL,data)
}
//保存积分接口
export function savePoints(data){
    //修改
    if (data.id) {
        return http.post(pointsAPI.UPDATE_URL, data)
    } else {
        //新增
        return http.post(pointsAPI.ADD_URL, data)
    }
}
//删除积分接口
export function deletePoints(id){
    return http.post(pointsAPI.DELETE_URL +'?id='+ id)
}

//删除积分接口
export function passApply(data){
    return http.post(pointsAPI.APPLY_URL ,data)
}

//删除积分接口
export function rejectApply(data){
    return http.post(pointsAPI.APPLY_URL ,data)
}
//-------------------------------- --------------------------